import dayjs, { Dayjs } from "utils/dayjs"

import { Guid } from "@/types"
import { ShippingOrderDisplayStatus, ShippingOrderType } from "./ShippingOrder"

export interface IGetShippingDashboardItemDto {
    reservationId: Guid
    shippingOrderId: Guid
    shippingOrderNumber: string
    departureDate: string
    arrivalDate: string
    departureDateMin?: string | null
    arrivalDateMax?: string | null
    customerName: string
    articleId: Guid
    status: ShippingOrderDisplayStatus
    type: ShippingOrderType
}

export default class ShippingDashboardItem {
    reservationId: Guid
    shippingOrderId: Guid
    shippingOrderNumber: string
    departureDate: Dayjs
    arrivalDate: Dayjs
    departureDateMin?: Dayjs | null
    arrivalDateMax?: Dayjs | null
    customerName: string
    status: ShippingOrderDisplayStatus
    type: ShippingOrderType
    articleDescription: Guid

    constructor(dto: IGetShippingDashboardItemDto, { articleDescription }: { articleDescription: string }) {
        this.reservationId = dto.reservationId
        this.shippingOrderId = dto.shippingOrderId
        this.shippingOrderNumber = dto.shippingOrderNumber
        this.departureDate = dayjs.utc(dto.departureDate)
        this.arrivalDate = dayjs.utc(dto.arrivalDate)
        this.departureDateMin = dto.departureDateMin ? dayjs.utc(dto.departureDateMin) : null
        this.arrivalDateMax = dto.arrivalDateMax ? dayjs.utc(dto.arrivalDateMax) : null
        this.customerName = dto.customerName
        this.status = dto.status
        this.type = dto.type
        this.articleDescription = articleDescription
    }
}
